export const experience = [
  {
    id: 1,
    date: "September'24 - Present",
    company: "Tenex Software Solutions",
    position: " Software Engineer",
    location:"Tampa, Florida, USA",
    desc:
      " • Developed and improved e-commerce application using Flutter widgets and state management approach like Provider \n" +
      " • Worked on loading images using Precache image libraries and compression techniques, enhancing performance of application from 2s to 200ms. Added localization / multi-language in flutter to support multiple languages in apps \n" +
      " • Created admin dashboard and integrated RESTful web services to enhance application features using .NET and MySQL \n" +
      " • Collaborated with user experience team to accomplish UI modifications based on provided wireframes, thereby simplifying and increasing user reach by 30% by making responsive design (multi-screen resolutions) using media query",
  },
  {
    id: 2,
    date: "January'23 - December'23",
    company: "Philips",
    position: " Software Engineer",
    location:"Cambridge, Massachusetts, USA",
    desc:
      " • Developed and improved e-commerce application using Flutter widgets and state management approach like Provider \n" +
      " • Worked on loading images using Precache image libraries and compression techniques, enhancing performance of application from 2s to 200ms. Added localization / multi-language in flutter to support multiple languages in apps \n" +
      " • Created admin dashboard and integrated RESTful web services to enhance application features using .NET and MySQL \n" +
      " • Collaborated with user experience team to accomplish UI modifications based on provided wireframes, thereby simplifying and increasing user reach by 30% by making responsive design (multi-screen resolutions) using media query",
  },
  // {
  //   id: 1,
  //   date: "January'22 - Present",
  //   company: "Northeastern University",
  //   position: " • Intramural Sports Official",
  //   position2: " • Facility Assistant, SquashBusters",
  //   location:"Boston, Massachusetts",
  //   desc:
  //     " • Developed and improved e-commerce application using Flutter widgets and state management approach like Provider \n" +
  //     " • Worked on loading images using Precache image libraries and compression techniques, enhancing performance of application from 2s to 200ms. Added localization / multi-language in flutter to support multiple languages in apps \n" +
  //     " • Created admin dashboard and integrated RESTful web services to enhance application features using .NET and MySQL \n" +
  //     " • Collaborated with user experience team to accomplish UI modifications based on provided wireframes, thereby simplifying and increasing user reach by 30% by making responsive design (multi-screen resolutions) using media query",
  // },
  {
    id: 3,
    date: "January'21 - August'21",
    company: "Infosoft Systems",
    position: "Full-Stack Developer",
    location:"Mumbai, Maharashtra, India",
    desc:
      " • Developed and improved e-commerce application using Flutter widgets and state management approach like Provider \n" +
      " • Worked on loading images using Precache image libraries and compression techniques, enhancing performance of application from 2s to 200ms. Added localization / multi-language in flutter to support multiple languages in apps \n" +
      " • Created admin dashboard and integrated RESTful web services to enhance application features using .NET and MySQL \n" +
      " • Collaborated with user experience team to accomplish UI modifications based on provided wireframes, thereby simplifying and increasing user reach by 30% by making responsive design (multi-screen resolutions) using media query",
  },
  {
    id: 4,
    date: "June'19 - December'20",
    company: "Appdid Infotech",
    position: "Frontend Developer",
    location:"Mumbai, Maharashtra, India",
    desc:
      " • Devised to build rich and dynamic mobile applications & progressive web apps with front-end frameworks like React & Flutter \n" +
      " • Brainstormed ideas for App’s enhancement, suggested technical improvements. Used modern UI and animated interface in making apps user friendly. Refactored components using ReactJS, from class-based components to functional components, integrating Hooks and reused 35% code by extracting components and widgets \n" +
      " • Researched and executed browser caching support through cache storage. Built and delivered 4 projects valued $80k on-time and within budget",
  },
];
